export enum DeleteProjectErrorCode
{
	AccessDenied = 'ACCESS_DENIED',
	TasksNotEmpty = 'TASKS_NOT_EMPTY',
	GroupWithFlow = 'GROUP_WITH_FLOW',
	DiskNotEmpty = 'DISK_NOT_EMPTY',
}
